import React from 'react';

export const Loader: React.FC = () => {
  return (
    <div className="inline-block w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
  );
};
